<app-header></app-header>
    
<app-carousel></app-carousel>

<div class="row">
    <div class="col col-12">

        <app-features></app-features>

        <div class="vincent_single_product_tab margin-top">
            <h2> {{length}} -  {{"reviews" | translate}} </h2>
            <div class="container">
                  <div class="vincent_comments_cont" *ngFor="let info of review;">
                     <div class="vincent_comment_block mrg-bottom">
                         <div class="vincent_comment_cont relveint-left-right">
                             <div class="vincent_blockquote_author">{{info.name}}@</div>
                             <blockquote>
                                 <p>{{info.message}}</p>
                                 <img class="review-img" [src]="info.photoUrl" (click)="basicModalsm.show()" style="cursor: pointer;">
                                 <div mdbModal #basicModalsm="mdbModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myBasicModalLabel" aria-hidden="true">
                                  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                                    <div class="modal-content">
                                        <div class="modal-body" style="text-align:center">
                                            <h4 class="modal-title" id="myModalLabel">{{"show_img" | translate}}</h4>
                                            <img [src]="info.photoUrl" class="img-responsive model-img">
                                        </div>
                                    </div>
                                  </div>
                                </div>
                                 <span class="review-rating" *ngIf="info.rating == 1">★</span>
                                 <span class="review-rating" *ngIf="info.rating == 2">★★</span>
                                 <span class="review-rating" *ngIf="info.rating == 3">★★★</span>
                                 <span class="review-rating" *ngIf="info.rating == 4">★★★★</span>
                                 <span class="review-rating" *ngIf="info.rating == 5">★★★★★</span>
                             </blockquote>
                         </div>
                     </div>
                 </div>
            </div>
             <div class="container">
                 <div class="vincent_tab3">
                 <p class="right" id="null-comments">{{"no_comments_yet" | translate}}</p>
                 <h5 class="vincent_form_title right" id="be-first">{{"be_the_first" | translate}}</h5>
                 <div class="vincent_form_block">
                     <p class="vincent_comment_notes right" id="wont_published">{{"your_email_wont_be_published" | translate}}</p>
                     <form class="rating float-right" id="rating">
                         <label>
                           <input type="radio" name="stars" value="1" [(ngModel)]="one" (change)="onItemChange($event.target.value)" />
                           <span class="icon">★</span>
                         </label>
                         <label>
                           <input type="radio" name="stars" value="2" [(ngModel)]="two" (change)="onItemChange($event.target.value)"/>
                           <span class="icon">★</span>
                           <span class="icon">★</span>
                         </label>
                         <label>
                           <input type="radio" name="stars" value="3" [(ngModel)]="three" (change)="onItemChange($event.target.value)"/>
                           <span class="icon">★</span>
                           <span class="icon">★</span>
                           <span class="icon">★</span>   
                         </label>
                         <label>
                           <input type="radio" name="stars" value="4" [(ngModel)]="four" (change)="onItemChange($event.target.value)"/>
                           <span class="icon">★</span>
                           <span class="icon">★</span>
                           <span class="icon">★</span>
                           <span class="icon">★</span>
                         </label>
                         <label>
                           <input type="radio" name="stars" value="5" [(ngModel)]="five" (change)="onItemChange($event.target.value)"/>
                           <span class="icon">★</span>
                           <span class="icon">★</span>
                           <span class="icon">★</span>
                           <span class="icon">★</span>
                           <span class="icon">★</span>
                         </label>
                       </form>
                     <form  class="vincent_form" #f="ngForm" (ngSubmit)="addReview(f)">
                         <textarea class="form_comment center" ngModel name="message" #message="ngModel" placeholder='{{"message" | translate}}' required></textarea>
                         <p *ngIf="message.invalid && message.touched" class="center mg-down-up">{{"please_enter_the_message" | translate}}</p>
      
                         <input type="text" class="form_user-name center" ngModel name="name" #name="ngModel" placeholder='{{"name" | translate}}' required>
                         <p *ngIf="name.invalid && name.touched" class="center mg-down-up">{{"please_enter_the_name" | translate}}</p>

                         <input type="file" ngModel #photoUrl name="photoUrl">
                        
                         <input class="" type="submit" value='{{"send" | translate}}' [disabled]="f.invalid || submit == false">									
                     </form>
                     <div class="alert alert-primary cus" role="alert" style="display: none;" id="done">
                      {{"comment_has_been_added" | translate}}
                      </div>
                 </div>
             </div>
          </div>
     </div>

    </div>
</div>

<app-footer></app-footer>